import Vue from "vue";
/*
 *控制权限指令 v-permission
 *使用该指令可以控制元素是否在页面展示。
 *示例：<div v-permission="['admin','editor']"></div>
 */

Vue.directive("permission", {
  // 指令的名称
  inserted(el, binding) {
    // el为绑定的元素，binding为绑定给指令的对象
    const { value } = binding;
    const { permissions } = JSON.parse(localStorage.getItem("userInfo"));
    if (value && value instanceof Array) {
      if (value.length > 0) {
        const permissionRoles = value;
        let hasPermission = false;
        if (permissions.includes("*")) {
          hasPermission = true;
        } else {
          hasPermission = permissions.some((role) => {
            return permissionRoles.includes(role);
          });
        }
        if (!hasPermission) {
          el.parentNode && el.parentNode.removeChild(el);
        }
      }
    } else {
      throw new Error(`需要配置按钮权限！例如v-permission="['admin','editor']"`);
    }
  },
});

/*
 *控制权限指令 v-debounce
 *使用该指令可以防止按钮在短时间内被多次点击，使用防抖函数限制规定时间内只能点击一次。
 *示例：<div v-debounce="debounceClick"></div>
     debounceClick () {
      console.log('只触发一次')
    }
 */

Vue.directive("debounce", {
  // 指令的名称
  inserted: function (el, binding) {
    let timer;
    el.addEventListener("keyup", () => {
      if (timer) {
        clearTimeout(timer);
      }
      timer = setTimeout(() => {
        binding.value();
      }, 1000);
    });
  },
});

/*
 *控制权限指令 v-loadmore
 *使用该指令el-select下拉加载的自定义指令
 *示例：<div v-loadmore="loadmore"></div>
     loadmore () {
      console.log('只触发一次')
    }
 */
Vue.directive("loadmore", {
  bind(el, binding) {
    const SELECTWRAP = el.querySelector(".el-select-dropdown .el-select-dropdown__wrap");
    SELECTWRAP.addEventListener("scroll", function () {
      // scrollTop 这里可能因为浏览器缩放存在小数点的情况，导致了滚动到底部时
      // scrollHeight 减去滚动到底部时的scrollTop ，依然大于clientHeight 导致无法请求更多数据
      // 这里将scrollTop向上取整 保证滚到底部时，触发调用
      const CONDITION = this.scrollHeight - Math.ceil(this.scrollTop) <= this.clientHeight;
      // el.scrollTop !== 0 当输入时，如果搜索结果很少，以至于没看到滚动条，那么此时的CONDITION计算结果是true，会执行bind.value()，此时不应该执行，否则搜索结果不匹配
      if (CONDITION && this.scrollTop !== 0) {
        binding.value();
      }
    });
  },
});
/* 
*响应缩放指令 v-resize
*使用该指令可以响应元素宽高改变时执行的方法。
*示例：<div v-resize="resize"></div> 
*methods:{
  resize(){
  }
}
*/
Vue.directive("resize", {
  // 指令的名称
  bind(el, binding) {
    // el为绑定的元素，binding为绑定给指令的对象
    let width = "",
      height = "";
    function isReize() {
      const style = document.defaultView.getComputedStyle(el);
      if (width !== style.width || height !== style.height) {
        binding.value(); // 关键
      }
      width = style.width;
      height = style.height;
    }
    el.__vueSetInterval__ = setInterval(isReize, 300);
  },
  unbind(el) {
    clearInterval(el.__vueSetInterval__);
  },
});
/*
 *文本内容复制指令 v-copy
 *使用该指令可以复制元素的文本内容（指令支持单击复制 v-copy、双击复制 v-copy.dblclick、点击icon复制 v-copy.icon 三种模式），不传参数时，默认使用单击复制
 *示例：<div v-copy> 单击复制 </div> <div v-copy.dblclick> 双击复制 </div> <div v-copy.icon> icon复制 </div>
 */
function copyHandleClick(text) {
  // 创建元素
  if (!document.getElementById("copyTarget")) {
    const copyTarget = document.createElement("input");
    copyTarget.setAttribute("style", "position:fixed;top:0;left:0;opacity:0;z-index:-1000;");
    copyTarget.setAttribute("id", "copyTarget");
    document.body.appendChild(copyTarget);
  }
  // 复制内容
  const input = document.getElementById("copyTarget");
  input.value = text;
  input.select();
  document.execCommand("copy");
  // alert('复制成功')
}
Vue.directive("copy", {
  bind(el, binding) {
    // 双击触发复制
    if (binding.modifiers.dblclick) {
      el.addEventListener("dblclick", () => copyHandleClick(el.innerText));
      el.style.cursor = "copy";
    }
    // 点击icon触发复制
    else if (binding.modifiers.icon) {
      if (el.hasIcon) return;
      const iconElement = document.createElement("i");
      iconElement.setAttribute("class", "el-icon-document-copy");
      iconElement.setAttribute("style", "margin-left:5px");
      el.appendChild(iconElement);
      el.hasIcon = true;
      iconElement.addEventListener("click", () => copyHandleClick(el.innerText));
      iconElement.style.cursor = "copy";
    }
    // 单击触发复制
    else {
      el.addEventListener("click", () => copyHandleClick(el.innerText));
      el.style.cursor = "copy";
    }
  },
});
/*
 *文字超出省略指令 v-ellipsis
 *使用该指令当文字内容超出宽度（默认 100% ）时自动变为省略形式
 *示例：<div v-ellipsis> 需要省略的文字xxxxxxxxxxxx副本</div>
 */
Vue.directive("ellipsis", {
  bind(el, binding) {
    if (binding.arg) {
      el.style.width = binding.arg + "px";
    } else {
      el.style.width = "100%";
    }
    el.style.whiteSpace = "nowrap";
    el.style.overflow = "hidden";
    el.style.textOverflow = "ellipsis";
  },
});
/*
 *字符串整形指令 v-format
 *使用该指令可以修改字符串，如使用 v-format.toFixed 保留两位小数、 v-format.price 将内容变成金额（每三位逗号分隔），可以同时使用，如 v-format.toFixed.price。
 *示例：例如将数字 243112.331 变成 243112.33，或 243,112.33。
 * <div v-format.toFixed.price="123333"></div>   显示结果123,333.00
 */
function formatNumber(num) {
  num += "";
  let strs = num.split(".");
  let x1 = strs[0];
  let x2 = strs.length > 1 ? "." + strs[1] : "";
  var rgx = /(\d+)(\d{3})/;
  while (rgx.test(x1)) {
    x1 = x1.replace(rgx, "$1" + "," + "$2");
  }
  return x1 + x2;
}
Vue.directive("format", {
  bind(el, binding) {
    const { value, modifiers } = binding;
    if (!value) return;
    let formatValue = value;
    if (modifiers.toFixed) {
      formatValue = value.toFixed(2);
    }
    console.log(formatValue);
    if (modifiers.price) {
      formatValue = formatNumber(formatValue);
    }
    el.innerText = formatValue;
  },
});

/*
 *控制权限指令 v-draggable
 *实现一个拖拽指令，可在页面可视区域任意拖拽元素。
 *思路：
  设置需要拖拽的元素为相对定位，其父元素为绝对定位。
  鼠标按下(onmousedown)时记录目标元素当前的 left 和 top 值。
  鼠标移动(onmousemove)时计算每次移动的横向距离和纵向距离的变化值，并改变元素的 left 和 top 值
  鼠标松开(onmouseup)时完成一次拖拽
 *示例：<div class="el-dialog" v-draggable></div>
 */

Vue.directive("draggable", {
  // 指令的名称
  inserted: function (el) {
    el.style.cursor = "move";
    el.onmousedown = function (e) {
      let disx = e.pageX - el.offsetLeft;
      let disy = e.pageY - el.offsetTop;
      document.onmousemove = function (e) {
        let x = e.pageX - disx;
        let y = e.pageY - disy;
        let maxX = document.body.clientWidth - parseInt(window.getComputedStyle(el).width);
        let maxY = document.body.clientHeight - parseInt(window.getComputedStyle(el).height);
        if (x < 0) {
          x = 0;
        } else if (x > maxX) {
          x = maxX;
        }

        if (y < 0) {
          y = 0;
        } else if (y > maxY) {
          y = maxY;
        }

        el.style.left = x + "px";
        el.style.top = y + "px";
      };
      document.onmouseup = function () {
        document.onmousemove = document.onmouseup = null;
      };
    };
  },
});
